<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.9375 3.90625C7.05425 3.90625 3.90625 7.05425 3.90625 10.9375C3.90625 14.8208 7.05425 17.9688 10.9375 17.9688C12.8793 17.9688 14.6361 17.1826 15.9093 15.9093C17.1826 14.6361 17.9688 12.8793 17.9688 10.9375C17.9688 7.05425 14.8208 3.90625 10.9375 3.90625ZM2.34375 10.9375C2.34375 6.1913 6.1913 2.34375 10.9375 2.34375C15.6837 2.34375 19.5312 6.1913 19.5312 10.9375C19.5312 13.029 18.7833 14.9469 17.5416 16.4367L22.4274 21.3226C22.7325 21.6277 22.7325 22.1223 22.4274 22.4274C22.1223 22.7325 21.6277 22.7325 21.3226 22.4274L16.4367 17.5416C14.9469 18.7833 13.029 19.5312 10.9375 19.5312C6.1913 19.5312 2.34375 15.6837 2.34375 10.9375Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgSearch',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
